import styled from 'styled-components';
import { PhoneInput } from 'react-international-phone';

export const StyledInput = styled(PhoneInput)<InputProps>`
  color: #595959;
  width: 100%;
  border-radius: 4px;
  border: 1px solid #999999;
  padding: 4px;
  height: 46px;
  ${(props) => (props.error ? `border-color: #f44336` : '')};

  .react-international-phone-country-selector-button {
    border: 0;
    padding: 0 8px;
  }

  .react-international-phone-flag-emoji {
    margin-right: 8px;
  }

  .react-international-phone-country-selector {
    border: 0;
  }

  .react-international-phone-input {
    border: 0;
    color: #595959;
  }

  .react-international-phone-country-selector-dropdown {
    width: max-content;
    padding: 4px;
  }

  .react-international-phone-country-selector-dropdown__list-item-country-name {
    display: none;
  }
`;

export const WrapperInputMask = styled.div`
  width: 100%;
  margin-bottom: 8px;
`;

export const Label = styled.label`
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 10px;
  color: #4d4d4d;
`;

interface HelperTextProps {
  error: boolean;
}

export const HelperText = styled.div<HelperTextProps>`
  display: inline-block;
  font-size: 12px;
  letter-spacing: 0em;
  text-align: left;
  color: ${(props) => (props.error ? '#f44336' : '#4d4d4d')};
`;

interface InputProps {
  error: boolean;
}
